import { FooterMenu } from "./components/FooterMenu";
import css from "./Footer.module.css";

export const BASE_CLASS = "f-OrganismFooter";

export const Footer = () => {
  return (
    <footer className={css[BASE_CLASS]}>
      <p>
        Copyright ©{new Date().getFullYear()} All rights reserved | This
        template is made with ❤️ by Oriol Puig
      </p>
      <FooterMenu />
    </footer>
  );
};
